import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const PublicAnnouncementPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/public-announcement'
    ),
);

const PublicAnnouncementRecordComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/public-announcement/record/AnnouncemnetRecordDialog'
    ),
);

const PublicAnnouncementManagementComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/public-announcement/management/PublicAnnouncementManagement'
    ),
);

const ScheduleManagementComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "public-announcement-page" */ '../../pages/public-announcement/schedule/ScheduleManagement'
    ),
);

const publicAnnouncementRouter = (
  <Route path="public-announcement">
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <PublicAnnouncementPageComponent />
        </Suspense>
      }
    >
      {accountRouter()}
      <Route
        path="record/:recordId"
        element={
          <Suspense fallback={<Loading />}>
            <PublicAnnouncementRecordComponent />
          </Suspense>
        }
      />
    </Route>
    <Route
      path=":projectId/management"
      element={
        <Suspense fallback={<Loading />}>
          <PublicAnnouncementManagementComponent />
        </Suspense>
      }
    />
    <Route
      path=":projectId/management-schedule"
      element={
        <Suspense fallback={<Loading />}>
          <ScheduleManagementComponent />
        </Suspense>
      }
    />
  </Route>
);

export default publicAnnouncementRouter;
